import { render, staticRenderFns } from "./UsersCardRightPanelCompetences.vue?vue&type=template&id=189cdad8&scoped=true&"
import script from "./UsersCardRightPanelCompetences.vue?vue&type=script&lang=ts&"
export * from "./UsersCardRightPanelCompetences.vue?vue&type=script&lang=ts&"
import style0 from "./UsersCardRightPanelCompetences.vue?vue&type=style&index=0&id=189cdad8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "189cdad8",
  null
  
)

export default component.exports